"use strict";
'use es6';

require("tinymce");